// Compassionate Beauty: hover zoom via CSS transform + cursor-following transform-origin
// Replaces Dawn's overlay approach with a more reliable scale-based zoom.

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach(function(image) {
    var mediaDiv = image.closest('.media');
    if (!mediaDiv) return;

    // Ensure the container clips the scaled image
    mediaDiv.style.overflow = 'hidden';
    image.style.transition = 'transform 0.35s ease';
    image.style.willChange = 'transform';
    image.style.cursor = 'zoom-in';

    // Update transform-origin to follow the cursor so the zoom centres on the pointer
    function onMove(e) {
      var rect = mediaDiv.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width  * 100).toFixed(2);
      var y = ((e.clientY - rect.top)  / rect.height * 100).toFixed(2);
      image.style.transformOrigin = x + '% ' + y + '%';
    }

    mediaDiv.addEventListener('mouseenter', function(e) {
      onMove(e);
      image.style.transform = 'scale(' + zoomRatio + ')';
    });

    mediaDiv.addEventListener('mousemove', onMove);

    mediaDiv.addEventListener('mouseleave', function() {
      image.style.transform = 'scale(1)';
    });
  });
}

enableZoomOnHover(1.8);
